import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterAssigned = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-assigned-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterAssigned.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterAssigned.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterAssigned.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterAssigned;
